// extracted by mini-css-extract-plugin
export default {"boxEllipse":"ContainerEllipseBlue_boxEllipse__e7CO8","boxEllipseTitle":"ContainerEllipseBlue_boxEllipseTitle__EcnTF","boxEllipseBtn":"ContainerEllipseBlue_boxEllipseBtn__DvrFf"};